import React from "react";
import Modal from "react-bootstrap/Modal";
import { Picker, GeneralButton } from "../../common/inputs";

function BulkManagingContactModal({
    show,
    onHide,
    managingContact,
    setManagingContact,
    managingContactList,
    onSubmit,
    isLoading,
    isVisible,
}) {
    if (!isVisible) return null;

    return (
        <Modal show={show} onHide={onHide} backdrop="static" centered>
            <Modal.Header closeButton />
            <Modal.Body>
                <h6>Change Managing Contact</h6>
                <div className="row mt-4">
                    <div className="col-lg-12 mb-2">
                        <Picker
                            items={managingContactList}
                            selectedItem={managingContactList.filter(
                                (item) => item.value === managingContact
                            )}
                            onSelectItem={(option) => setManagingContact(option.value)}
                        />
                    </div>
                    <div className="col-lg-12">
                        <p className="alert alert-info">* Please be aware that any changes made to the settings will be automatically reflected in the HubSpot profile.</p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <GeneralButton
                onClick={onSubmit}
                name={isLoading ? "Updating..." : "Update Managing Contact"}
                disabled={isLoading}
                />
            </Modal.Footer>
        </Modal>
    );
}

export default BulkManagingContactModal;